import { Outlet } from "react-router-dom";
import { usePageWrapper } from "../../../hooks";

const MessagingConfiguration = () => <Outlet />;

export default usePageWrapper(MessagingConfiguration, {
  page_title: "Email Configuration",
});
